module.exports = __webpack_public_path__ + "img/wallet.de7b477f.svg";